module.exports = __webpack_public_path__ + "static/media/24-9.535901f4.mp3";